/*
  Mobile only: the header menu's "Buy Now" link (#first-legend-product) lands
  on the first product in the homepage's mobile product list (e.g. "Signature Edition
  Box Set / Rebel Tear Stone Edition") instead of the "Meet Our Collectors"
  heading that #first-legend-product points at. Desktop is unchanged.

  Runs in the capture phase so it handles the click before totl-theme.js's
  own smooth-anchor handler, and uses the same easing, duration and header
  clearance so it feels identical.
*/
(function () {
  var mobile = window.matchMedia('(max-width: 767px)');

  function clamp(value, min, max) { return Math.min(max, Math.max(min, value)); }
  function easeInOutCubic(t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; }

  function firstMobileProduct() {
    var items = document.querySelectorAll('#first-legend-product .tb-list__item.is-product');
    for (var i = 0; i < items.length; i++) {
      if (items[i].offsetParent !== null) return items[i];
    }
    return null;
  }

  function closeMenu() {
    var toggle = document.querySelector('[data-totl-menu-toggle]');
    if (toggle && toggle.getAttribute('aria-expanded') === 'true') toggle.click();
  }

  function scrollToTarget(target) {
    var nav = document.querySelector('.navbar.w-nav');
    var offset = (nav ? nav.getBoundingClientRect().height : 0) + 16;
    var start = window.scrollY || window.pageYOffset || 0;
    var end = Math.max(0, start + target.getBoundingClientRect().top - offset);
    var duration = clamp(Math.abs(end - start) * 0.45, 600, 1700);
    var startTime = performance.now();
    var html = document.documentElement;
    var previous = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';

    function step(now) {
      var t = clamp((now - startTime) / duration, 0, 1);
      window.scrollTo(0, start + (end - start) * easeInOutCubic(t));
      if (t < 1) {
        window.requestAnimationFrame(step);
      } else {
        html.style.scrollBehavior = previous;
        // Re-measure once in case lazy images above shifted the layout.
        var fresh = Math.max(0, (window.scrollY || 0) + target.getBoundingClientRect().top - offset);
        if (Math.abs(fresh - (window.scrollY || 0)) > 2) window.scrollTo(0, fresh);
      }
    }
    window.requestAnimationFrame(step);
  }

  document.addEventListener('click', function (event) {
    if (!mobile.matches) return;
    var link = event.target.closest && event.target.closest('#MainNavigation a[href$="#first-legend-product"]');
    if (!link) return;
    var target = firstMobileProduct();
    if (!target) return;

    event.preventDefault();
    event.stopPropagation();
    closeMenu();
    // Let the menu close (and the header settle) before measuring.
    window.requestAnimationFrame(function () { scrollToTarget(target); });
  }, true);
})();
